'use strict';
/* ============================================================
   L'INTERDIT v4 — Theme JavaScript
   ============================================================ */

// ── AGE GATE ──
const AgeGate = {
  init() {
    if (sessionStorage.getItem('li_age_ok')) return;
    const gate = document.getElementById('age-gate');
    if (!gate) return;
    gate.style.display = 'flex';
    document.body.classList.add('no-scroll');

    document.getElementById('age-confirm')?.addEventListener('click', () => {
      sessionStorage.setItem('li_age_ok', '1');
      gate.style.opacity = '0';
      gate.style.transition = 'opacity .5s ease';
      setTimeout(() => { gate.remove(); document.body.classList.remove('no-scroll'); }, 500);
    });
  }
};

// ── HEADER SCROLL ──
const HeaderScroll = {
  init() {
    const h = document.querySelector('.site-header');
    if (!h) return;
    window.addEventListener('scroll', () => {
      h.classList.toggle('scrolled', window.scrollY > 60);
    }, { passive: true });
  }
};

// ── MOBILE MENU ──
const MobileMenu = {
  open: false,
  init() {
    this.btn     = document.getElementById('hamburger');
    this.panel   = document.getElementById('mobile-nav');
    this.overlay = document.getElementById('mnav-overlay');
    this.closeBtn= document.getElementById('mnav-close');
    if (!this.btn || !this.panel) return;

    this.btn.addEventListener('click', () => this.toggle());
    this.closeBtn?.addEventListener('click', () => this.close());
    this.overlay?.addEventListener('click', () => this.close());

    // Ferme sur clic lien
    this.panel.querySelectorAll('a').forEach(a => a.addEventListener('click', () => this.close()));

    document.addEventListener('keydown', e => { if (e.key === 'Escape') this.close(); });
  },
  toggle() { this.open ? this.close() : this.openMenu(); },
  openMenu() {
    this.open = true;
    this.panel.classList.add('is-open');
    this.overlay?.classList.add('is-open');
    this.btn.classList.add('is-open');
    this.btn.setAttribute('aria-expanded', 'true');
    document.body.classList.add('no-scroll');
  },
  close() {
    this.open = false;
    this.panel.classList.remove('is-open');
    this.overlay?.classList.remove('is-open');
    this.btn.classList.remove('is-open');
    this.btn.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('no-scroll');
  }
};

// ── CART DRAWER ──
const Cart = {
  isOpen: false,
  init() {
    const drawer  = document.getElementById('cart-drawer');
    const overlay = drawer?.querySelector('.cart-drawer__overlay');
    const closeBtn= drawer?.querySelector('.cart-drawer__close');

    overlay?.addEventListener('click', () => this.close());
    closeBtn?.addEventListener('click', () => this.close());
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && this.isOpen) this.close(); });

    document.querySelectorAll('[data-cart-open]').forEach(b => b.addEventListener('click', () => this.open()));
  },
  open() {
    document.getElementById('cart-drawer')?.classList.add('is-open');
    document.body.classList.add('no-scroll');
    this.isOpen = true;
    this.render();
  },
  close() {
    document.getElementById('cart-drawer')?.classList.remove('is-open');
    document.body.classList.remove('no-scroll');
    this.isOpen = false;
  },
  async render() {
    try {
      const res  = await fetch('/cart.js');
      const data = await res.json();
      this.updateBadge(data.item_count);

      const el    = document.getElementById('cart-items');
      const total = document.getElementById('cart-total');
      if (total) total.textContent = this.money(data.total_price);

      if (!el) return;
      if (!data.items.length) {
        el.innerHTML = `<div class="cart-empty"><p>Votre panier est vide</p><p>Découvrez notre collection</p></div>`;
        return;
      }
      el.innerHTML = data.items.map(item => `
        <div class="cart-item" data-key="${item.key}">
          <img class="cart-item__img" src="${item.image || ''}" alt="${item.title}">
          <div>
            <p class="cart-item__name">${item.product_title}</p>
            ${item.variant_title ? `<p class="cart-item__var">${item.variant_title}</p>` : ''}
            <p class="cart-item__price">${this.money(item.final_price)}</p>
            <div class="cart-item__qty">
              <button class="qty-btn" onclick="Cart.setQty('${item.key}',${item.quantity - 1})">−</button>
              <span class="qty-val">${item.quantity}</span>
              <button class="qty-btn" onclick="Cart.setQty('${item.key}',${item.quantity + 1})">+</button>
            </div>
          </div>
          <button class="cart-item__del" onclick="Cart.setQty('${item.key}',0)" aria-label="Supprimer">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
        </div>`).join('');
    } catch(e) { console.error('Cart render:', e); }
  },
  async setQty(key, qty) {
    try {
      const res  = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      const data = await res.json();
      this.updateBadge(data.item_count);
      this.render();
    } catch(e) { console.error('Cart setQty:', e); }
  },
  updateBadge(n) {
    document.querySelectorAll('.cart-badge').forEach(el => {
      el.textContent = n;
      el.style.display = n > 0 ? 'flex' : 'none';
    });
  },
  money(cents) {
    return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
  }
};

// ── ADD TO CART ──
const AddToCart = {
  init() {
    document.querySelectorAll('[data-add-to-cart]').forEach(form => {
      form.addEventListener('submit', async e => {
        e.preventDefault();
        const btn = form.querySelector('[type="submit"]');
        const fd  = new FormData(form);
        btn.disabled = true;
        const orig = btn.textContent;
        btn.textContent = 'Ajout…';
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: fd.get('id'), quantity: parseInt(fd.get('quantity') || 1) })
          });
          if (res.ok) {
            const cartRes  = await fetch('/cart.js');
            const cartData = await cartRes.json();
            Cart.updateBadge(cartData.item_count);
            Toast.show('Produit ajouté au panier');
            Cart.open();
            btn.textContent = '✓ Ajouté';
            setTimeout(() => { btn.disabled = false; btn.textContent = orig; }, 2200);
          } else {
            throw new Error('add failed');
          }
        } catch {
          btn.disabled = false;
          btn.textContent = 'Réessayer';
        }
      });
    });
  }
};

// ── QUANTITY SELECTOR ──
const QtySelector = {
  init() {
    document.querySelectorAll('.qty-selector').forEach(sel => {
      const input = sel.querySelector('input');
      sel.querySelector('[data-dec]')?.addEventListener('click', () => {
        const v = parseInt(input.value) || 1;
        if (v > 1) input.value = v - 1;
      });
      sel.querySelector('[data-inc]')?.addEventListener('click', () => {
        input.value = (parseInt(input.value) || 1) + 1;
      });
    });
  }
};

// ── PRODUCT GALLERY ──
const Gallery = {
  init() {
    const main   = document.querySelector('.gallery__main img');
    const thumbs = document.querySelectorAll('.gallery__thumb');
    if (!main || !thumbs.length) return;
    thumbs.forEach(th => {
      th.addEventListener('click', () => {
        thumbs.forEach(t => t.classList.remove('active'));
        th.classList.add('active');
        // On utilise l'URL haute résolution stockée dans data-full
        const fullSrc = th.getAttribute('data-full');
        const thumbSrc = th.querySelector('img')?.src;
        if (fullSrc) {
          main.src = fullSrc;
        } else if (thumbSrc) {
          main.src = thumbSrc;
        }
      });
    });
  }
};

// ── VARIANT SELECT (taille, couleur, etc.) ──
const Variants = {
  init() {
    const select = document.getElementById('variantSelect');
    if (!select) return; // Pas de variantes sur ce produit

    document.querySelectorAll('.variant-opt').forEach(btn => {
      btn.addEventListener('click', () => {
        // 1. Marquer cette option comme active dans son groupe
        const group = btn.closest('.variant-options');
        group?.querySelectorAll('.variant-opt').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');

        // 2. Mettre à jour le label "Couleur : Rouge"
        const optionPos = btn.dataset.option;
        const value = btn.dataset.value;
        const currentLabel = document.querySelector(`.variant-current[data-option="${optionPos}"]`);
        if (currentLabel) currentLabel.textContent = value;

        // 3. Récupérer toutes les options actives pour trouver la bonne variante
        const activeValues = [];
        document.querySelectorAll('.variant-options').forEach(grp => {
          const active = grp.querySelector('.variant-opt.active');
          if (active) activeValues.push(active.dataset.value);
        });

        // 4. Trouver l'option <select> qui correspond à toutes les valeurs choisies
        const options = select.querySelectorAll('option');
        for (let opt of options) {
          const optVals = opt.dataset.options?.split(',') || [];
          if (activeValues.length === optVals.length &&
              activeValues.every((v, i) => v === optVals[i])) {
            select.value = opt.value;
            break;
          }
        }

        // 5. Si une image variant existe, la charger
        // (Shopify auto-détecte ça via les couleurs si elles ont des images associées)
      });
    });
  }
};

// ── WISHLIST ──
const Wishlist = {
  init() {
    document.querySelectorAll('.product-card__wish').forEach(btn => {
      btn.addEventListener('click', e => {
        e.preventDefault(); e.stopPropagation();
        btn.classList.toggle('is-active');
        const active = btn.classList.contains('is-active');
        Toast.show(active ? 'Ajouté aux favoris ♡' : 'Retiré des favoris');
      });
    });
  }
};

// ── TOAST ──
const Toast = {
  timer: null,
  show(msg, duration = 2800) {
    const el = document.getElementById('toast');
    if (!el) return;
    el.querySelector('.toast__msg').textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(this.timer);
    this.timer = setTimeout(() => el.classList.remove('is-visible'), duration);
  }
};

// ── NEWSLETTER ──
const Newsletter = {
  init() {
    document.querySelectorAll('.nl-form').forEach(form => {
      form.addEventListener('submit', async e => {
        e.preventDefault();
        const input = form.querySelector('.nl-input');
        const btn   = form.querySelector('.btn');
        if (!input?.value.includes('@')) return;
        btn.disabled = true; btn.textContent = 'Inscription…';
        try {
          await fetch('/contact#newsletter', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams({ form_type: 'customer', 'utf8': '✓', 'customer[email]': input.value, 'customer[tags]': 'newsletter' })
          });
          btn.textContent = '✓ Inscrit(e)';
          input.value = '';
          Toast.show('Bienvenue dans l\'univers L\'Interdit !');
        } catch {
          btn.disabled = false; btn.textContent = 'Réessayer';
        }
      });
    });
  }
};

// ── SCROLL ANIMATIONS ──
const ScrollAnim = {
  init() {
    const obs = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.fade-in').forEach(el => obs.observe(el));
  }
};

// ── INIT ──
document.addEventListener('DOMContentLoaded', () => {
  AgeGate.init();
  HeaderScroll.init();
  MobileMenu.init();
  Cart.init();
  AddToCart.init();
  QtySelector.init();
  Gallery.init();
  Variants.init();
  Wishlist.init();
  Newsletter.init();
  ScrollAnim.init();
  Lightbox.init();
});

// ── LIGHTBOX (zoom photos produit) ──
const Lightbox = {
  images: [],
  currentIndex: 0,

  init() {
    const lightbox = document.getElementById('lightbox');
    if (!lightbox) return;

    const lbImg     = document.getElementById('lightboxImg');
    const lbClose   = document.getElementById('lightboxClose');
    const lbPrev    = document.getElementById('lightboxPrev');
    const lbNext    = document.getElementById('lightboxNext');
    const lbCounter = document.getElementById('lightboxCounter');

    // Récolte toutes les images zoomables sur la page produit
    this.collectImages();

    if (this.images.length === 0) return;

    // Image principale cliquable → ouvre le lightbox
    const mainContainer = document.querySelector('.gallery__main');
    if (mainContainer) {
      mainContainer.addEventListener('click', () => {
        const mainImg = document.getElementById('gallery-main-img');
        const currentSrc = mainImg?.src;
        const idx = this.images.findIndex(src => src === currentSrc);
        this.open(idx >= 0 ? idx : 0);
      });
    }

    // Navigation
    lbClose.addEventListener('click', () => this.close());
    lbPrev.addEventListener('click', () => this.prev());
    lbNext.addEventListener('click', () => this.next());

    // Click sur fond noir = fermer
    lightbox.addEventListener('click', e => {
      if (e.target === lightbox) this.close();
    });

    // Clavier
    document.addEventListener('keydown', e => {
      if (!lightbox.classList.contains('is-open')) return;
      if (e.key === 'Escape') this.close();
      if (e.key === 'ArrowLeft') this.prev();
      if (e.key === 'ArrowRight') this.next();
    });

    // Swipe sur mobile
    let touchStartX = 0;
    lightbox.addEventListener('touchstart', e => {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });
    lightbox.addEventListener('touchend', e => {
      const diff = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) this.prev(); else this.next();
      }
    });
  },

  collectImages() {
    this.images = [];
    // Récupère les URLs haute résolution depuis data-full des miniatures
    document.querySelectorAll('.gallery__thumb').forEach(th => {
      const full = th.getAttribute('data-full');
      if (full) this.images.push(full);
    });
    // Si pas de miniatures, prendre l'image principale
    if (this.images.length === 0) {
      const mainImg = document.getElementById('gallery-main-img');
      if (mainImg?.src) this.images.push(mainImg.src);
    }
  },

  open(index) {
    if (this.images.length === 0) return;
    const lightbox = document.getElementById('lightbox');
    this.currentIndex = Math.max(0, Math.min(index, this.images.length - 1));
    this.render();
    lightbox.classList.add('is-open');
    document.body.classList.add('lightbox-open');
  },

  close() {
    const lightbox = document.getElementById('lightbox');
    lightbox.classList.remove('is-open');
    document.body.classList.remove('lightbox-open');
  },

  prev() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.render();
    }
  },

  next() {
    if (this.currentIndex < this.images.length - 1) {
      this.currentIndex++;
      this.render();
    }
  },

  render() {
    const lbImg     = document.getElementById('lightboxImg');
    const lbCounter = document.getElementById('lightboxCounter');
    const lbPrev    = document.getElementById('lightboxPrev');
    const lbNext    = document.getElementById('lightboxNext');

    lbImg.src = this.images[this.currentIndex];
    lbCounter.textContent = `${this.currentIndex + 1} / ${this.images.length}`;

    lbPrev.classList.toggle('is-disabled', this.currentIndex === 0);
    lbNext.classList.toggle('is-disabled', this.currentIndex === this.images.length - 1);

    // Cache les boutons nav s'il n'y a qu'une image
    if (this.images.length <= 1) {
      lbPrev.style.display = 'none';
      lbNext.style.display = 'none';
      lbCounter.style.display = 'none';
    }
  }
};

// ── CODE PROMO DRAWER ──
const PromoCode = {
  init() {
    const toggle = document.getElementById('cartPromoToggle');
    const field  = document.getElementById('cartPromoField');
    const block  = document.getElementById('cartPromoBlock');
    if (!toggle) return;

    toggle.addEventListener('click', () => {
      const open = field.style.display === 'none';
      field.style.display = open ? 'block' : 'none';
      block.classList.toggle('open', open);
    });
  }
};

async function applyPromo() {
  const input = document.getElementById('promoInput');
  const msg   = document.getElementById('promoMsg');
  const btn   = document.getElementById('promoApply');
  const code  = input?.value.trim().toUpperCase();
  if (!code) return;

  btn.disabled = true;
  btn.textContent = '…';
  msg.style.display = 'none';

  try {
    // Appliquer le code via l'API cart Shopify
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: code })
    });
    // Rediriger vers /cart pour voir la réduction appliquée par Shopify
    window.location.href = '/cart?discount=' + encodeURIComponent(code);
  } catch(e) {
    msg.textContent = 'Impossible d\'appliquer le code. Réessayez.';
    msg.className = 'promo-msg--err';
    msg.style.display = 'block';
    btn.disabled = false;
    btn.textContent = 'Appliquer';
  }
}

// Ajouter init dans DOMContentLoaded
document.addEventListener('DOMContentLoaded', () => {
  PromoCode.init();
});
